import { render, staticRenderFns } from "./RareClientMenu.vue?vue&type=template&id=5cf10b19&scoped=true"
import script from "./RareClientMenu.vue?vue&type=script&lang=js"
export * from "./RareClientMenu.vue?vue&type=script&lang=js"
import style0 from "./RareClientMenu.vue?vue&type=style&index=0&id=5cf10b19&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf10b19",
  null
  
)

export default component.exports